module["exports"] = [
  "#{last_name} #{first_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/name/name.js
// module id = 1499
// module chunks = 1